import React from "react";
import Reveal from "./Reveal";

const STAGES = [
  {
    n: "01",
    title: "Discovery Call",
    body:
      "We understand your context — audience, scale, AI maturity, business goals, timeline. A 30-minute conversation, no commitment.",
  },
  {
    n: "02",
    title: "Proposal in 48 Hours",
    body:
      "A custom-scoped programme matched to your context. Tier (Native / Builder / Leader), channel, delivery mode, capstone, pricing.",
  },
  {
    n: "03",
    title: "Programme Delivery",
    body:
      "Hybrid — physical and online. Pod-based for institutions. Cohort plus roleplay for corporates. Self-paced plus community for individuals.",
  },
  {
    n: "04",
    title: "Innovation Arena or Capstone",
    body:
      "Every programme ends in a shippable artifact, not a quiz. Institutions get an on-campus Innovation Arena edition. Corporates get function-specific deployment projects.",
  },
  {
    n: "05",
    title: "Post-Programme Compounding",
    body:
      "Top performers enter the AI For Everyone ecosystem: mentorship, AI job marketplace, pitch hub for founders, backing for the strongest.",
  },
];

export default function HowWeEngage() {
  return (
    <section
      id="engage"
      className="py-10 md:py-14 border-t hairline"
      data-testid="engage-section"
    >
      <div className="container-edge">
        <Reveal>
          <p className="section-number">08 — HOW WE ENGAGE</p>
        </Reveal>
        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <Reveal>
              <h2
                className="font-display text-[40px] sm:text-[52px] lg:text-[68px] leading-[0.95] tracking-tight"
                style={{ fontWeight: 500 }}
              >
                Five stages.
                <br />
                <em className="italic grad-brand-text" style={{ fontWeight: 500 }}>
                  From discovery to compounding capability.
                </em>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <Reveal delay={120}>
              <p
                className="text-[17px] md:text-[19px] leading-relaxed"
                style={{ color: "var(--ink-secondary)" }}
              >
                Every engagement — whether you're a school, college, corporate, or individual —
                follows the same five stages. Custom-scoped to your context. Built to deliver
                capability that outlasts the engagement.
              </p>
            </Reveal>
          </div>
        </div>

        {/* Vertical ladder */}
        <div className="mt-12 divide-y" style={{ borderColor: "var(--border-soft)" }}>
          {STAGES.map((s, i) => (
            <Reveal key={s.n} delay={i * 50}>
              <div
                className="grid grid-cols-12 gap-6 py-7 border-t hairline"
                data-testid={`stage-${s.n}`}
              >
                <div className="col-span-12 md:col-span-2">
                  <p
                    className="font-mono text-[12px]"
                    style={{ color: "var(--accent-gold)", letterSpacing: "0.14em" }}
                  >
                    STAGE {s.n}
                  </p>
                </div>
                <div className="col-span-12 md:col-span-4">
                  <h3
                    className="font-display text-[26px] md:text-[30px] tracking-tight"
                    style={{ fontWeight: 500 }}
                  >
                    {s.title}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-6">
                  <p
                    className="text-[15px] leading-relaxed"
                    style={{ color: "var(--ink-secondary)" }}
                  >
                    {s.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
